module.exports = __webpack_public_path__ + "img/balibodySh3.f7a23dd0.jpg";